import { Answers } from "../types/answers";
import api from "./api";

export const listAnswers = async (
  id: number,
  phone?: string
): Promise<Answers[]> => {
  const response = await api.get("report-:stage/answers/list", {
    params: { id_campanha: id, phone },
  });

  return response.data.content;
};
